module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAaCAMAAAD/jJ6+AAAAM1BMVEVHcEysr7GrrK6rrK6ur7Grrq+rrK6rrK61v7+rrK6rrK6rrK6qrK6ws7OsrK+rrK6qq63f2JbkAAAAEHRSTlMAKZy7HDSt7AfeivjIEEdwCMHYKwAAAKBJREFUOMvF1NsSAxEMBuCwi2CV93/aOmynOpvav1fNhYvMN5iEEMGxp7oYbxOkc4yGSJfid0CHUkomekTIN30wgb7rcWnATxrweta3vumNp8TSX3St/lfPgj69ErSVdPVO9E1bFk5t3ilhb1FLfqWvnreVJlIfvmvNi/Z1b2a9fkpvnwBdvR8+HYh++a4D9CWbh/XwuD59+GFEWJfpD/EEgDYK3KlXSxoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bottom.png
// module id = LMMY
// module chunks = 0